// extracted by mini-css-extract-plugin
export default {"root":"checkboxes_wrapper-module___root___b3f2d365","checkboxes":"checkboxes_wrapper-module___checkboxes___ef1a8cbb","error":"checkboxes_wrapper-module___error___a0c3472f"};